import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Paper,
  Stack,
  ListItemText,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import { CheckCircle, Error, PlayArrow } from "@mui/icons-material";

import { initLocalization } from "../../../utils/helpers";
import { spendsTotalCardsStrings } from "./locale";

export const SpendsTotalCards = ({ totals }) => {
  initLocalization(spendsTotalCardsStrings);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} key="finished">
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderLeft: "6px solid",
              borderLeftColor: "success.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack>
              <Typography
                variant="overline"
                sx={{ fontWeight: "bold", color: "text.secondary" }}
              >
                {spendsTotalCardsStrings.finished}
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                {totals.finished}
              </Typography>
            </Stack>
            <Box
              sx={{
                color: "success.main",
                display: "flex",
                fontSize: "2rem",
              }}
            >
              {<CheckCircle fontSize="inherit" />}
            </Box>
          </Paper>
        </Grid>

        <Grid xs={12} sm={3} key="inProgress">
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderLeft: "6px solid",
              borderLeftColor: "warning.light",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack>
              <Typography
                variant="overline"
                sx={{
                  fontWeight: "bold",
                  color: "text.secondary",
                  whiteSpace: "nowrap",
                }}
              >
                {spendsTotalCardsStrings.inProgress}
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                {totals.inProgress}
              </Typography>
            </Stack>
            <Box
              sx={{
                color: "warning.light",
                display: "flex",
                fontSize: "2.5rem",
              }}
            >
              {<PlayArrow fontSize="inherit" />}
            </Box>
          </Paper>
        </Grid>

        <Grid xs={12} sm={3} key="error">
          <Paper
            elevation={2}
            sx={{
              p: 3,
              borderLeft: "6px solid",
              borderLeftColor: "error.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Stack>
              <Typography
                variant="overline"
                sx={{ fontWeight: "bold", color: "text.secondary" }}
              >
                {spendsTotalCardsStrings.error}
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                {totals.error}
              </Typography>
            </Stack>
            <Box
              sx={{ color: "error.main", display: "flex", fontSize: "2rem" }}
            >
              {<Error fontSize="inherit" />}
            </Box>
          </Paper>
        </Grid>

        <Grid xs={12} sm={3}>
          <Paper
            elevation={2}
            sx={{
              py: 1,
              px: 3,
              minHeight: "100px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="overline"
              sx={{ fontWeight: "bold", mb: 0.5, display: "block" }}
            >
              {spendsTotalCardsStrings.legend}
            </Typography>

            <List sx={{ p: 0 }}>
              <ListItem key="finished" sx={{ p: 0 }}>
                <ListItemIcon sx={{ minWidth: 24 }}>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor: "success.main",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={spendsTotalCardsStrings.finished}
                  primaryTypographyProps={{
                    variant: "caption",
                    fontWeight: 500,
                  }}
                  sx={{ my: 0.2 }}
                />
              </ListItem>

              <ListItem key="inProgress" sx={{ p: 0 }}>
                <ListItemIcon sx={{ minWidth: 24 }}>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor: "warning.light",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={spendsTotalCardsStrings.inProgress}
                  primaryTypographyProps={{
                    variant: "caption",
                    fontWeight: 500,
                  }}
                  sx={{ my: 0.2, whiteSpace: "nowrap" }}
                />
              </ListItem>

              <ListItem key="error" sx={{ p: 0 }}>
                <ListItemIcon sx={{ minWidth: 24 }}>
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      bgcolor: "error.main",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={spendsTotalCardsStrings.error}
                  primaryTypographyProps={{
                    variant: "caption",
                    fontWeight: 500,
                  }}
                  sx={{ my: 0.2 }}
                />
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

SpendsTotalCards.propTypes = {
  totals: PropTypes.object.isRequired,
};
